<template>
  <div class="toggle-switch">
    <div
        :class="modelValue === variants[0].value? 'toggle active': 'toggle'"
        @click="updateValue(variants[0].value)"
    >
      {{ variants[0].title }}
    </div>
    <div
        :class="modelValue === variants[1].value? 'toggle active': 'toggle'"
        @click="updateValue(variants[1].value)"
    >
      {{ variants[1].title }}
    </div>
  </div>
</template>

<script setup>
import {defineProps, defineEmits} from 'vue';

defineProps({
  modelValue: {
    type: Number,
    default: 0,
  },
  variants: {
    type: Array,
  }
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (newValue) => {
  emit('update:modelValue', newValue);
};
</script>

<style scoped>
.toggle-switch {
  display: flex;
  height: 36px;
  color: #626262;
}

.toggle {
  display: grid;
  place-items: center;
  flex-basis: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.toggle-switch div:first-child {
  border-radius: 3px 0 0 3px;
  border: 1px solid #CFCFCF;
  border-right: 0;
}

.toggle-switch div:last-child {
  border-radius: 0 3px 3px 0;
  border: 1px solid #CFCFCF;
  border-left: 0;
}

.active {
  color: #3A5A8F;
  background: #F0F5FC;
  border: 1px solid #3A5A8F !important;
}
</style>
